import {
    GET_FEATURE_FILE_TYPES_FAIL,
    GET_FEATURE_FILE_TYPES_SUCCESS,
    ADD_FEATURE_FILE_TYPE_SUCCESS,
    ADD_FEATURE_FILE_TYPE_FAIL,
    UPDATE_FEATURE_FILE_TYPE_SUCCESS,
    UPDATE_FEATURE_FILE_TYPE_FAIL,
    DELETE_FEATURE_FILE_TYPE_SUCCESS,
    DELETE_FEATURE_FILE_TYPE_FAIL,
} from "./actionTypes";

const INIT_STATE = {
    featureFileTypes: [],
    error: null,
    loading: true
};

const featureFileTypeReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        // Récupération des featureFileTypes
        case GET_FEATURE_FILE_TYPES_SUCCESS:
            return {
                ...state,
                featureFileTypes: action.payload, // tableau d'objets featureFileType
                loading: false,
                error: null
            };

        case GET_FEATURE_FILE_TYPES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        // Ajout d'une featureFileTypee
        case ADD_FEATURE_FILE_TYPE_SUCCESS:
            return {
                ...state,
                featureFileTypes: [action.payload, ...state.featureFileTypes], // ajoute au début du tableau
                error: null
            };

        case ADD_FEATURE_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Mise à jour d'une featureFileTypee
        case UPDATE_FEATURE_FILE_TYPE_SUCCESS:
            return {
                ...state,
                featureFileTypes: state.featureFileTypes.map(featureFileType =>
                    featureFileType.id.toString() === action.payload.id.toString()
                        ? action.payload // remplace entièrement l'objet featureFileType
                        : featureFileType
                ),
                error: null
            };

        case UPDATE_FEATURE_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        // Suppression d'une featureFileTypee
        case DELETE_FEATURE_FILE_TYPE_SUCCESS:
            return {
                ...state,
                featureFileTypes: state.featureFileTypes.filter(
                    featureFileType => featureFileType.id !== action.payload
                ),
                error: null
            };


        case DELETE_FEATURE_FILE_TYPE_FAIL:
            return {
                ...state,
                error: action.payload
            };

        default:
            return state;
    }
};

export default featureFileTypeReducer;
